import { render, staticRenderFns } from "./Trees.vue?vue&type=template&id=b47b8c04&scoped=true&"
import script from "./Trees.vue?vue&type=script&lang=js&"
export * from "./Trees.vue?vue&type=script&lang=js&"
import style0 from "./Trees.vue?vue&type=style&index=0&id=b47b8c04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47b8c04",
  null
  
)

export default component.exports